export default __webpack_public_path__ + "media/images/icons_fc/folder-fe6156ee7d539a1ec61ac749f7744717.png";